<template>
  <el-dialog :title="title" :visible.sync="showDialog" width="450px" class="returnVisit" @close="closeEvent">
    <el-form :model="addForm" :inline="true" class="sb_com_input" ref="ruleForm" :rules="formRule" label-width="90px">
      <el-form-item label="公司名称:" style="width: 100%;text-align: left;">
        <el-input type="text" :rows="3" placeholder="请输入内容" v-model="name" disabled size="mini"></el-input>
      </el-form-item>
      <el-form-item label="回访时间:" prop="visit_time" style="width: 100%;text-align: left;">
        <el-date-picker
          type="datetime"
          placeholder="选择日期时间"
          v-model="addForm.visit_time"
          style="width: 100%;"
          size="mini"
           :picker-options="returnPickerOptions"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="回访对象:" prop="visit_name" style="width: 100%;text-align: left;">
        <el-input
          type="text"
          :rows="3"
          placeholder="请输入内容"
          v-model="addForm.visit_name"
          size="mini"
        ></el-input>
      </el-form-item>
      <el-form-item label="回访方式:" prop="type" style="width: 100%;text-align: left;">
        <el-select v-model="addForm.type" placeholder="请选择回访方式" size="mini">
          <el-option label="电话" value="1"></el-option>
          <el-option label="网络" value="2"></el-option>
          <el-option label="上门" value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="回访内容:" prop="visit_content" style="width: 100%;text-align: left;margin-top: 10px;">
        <el-input
          type="textarea"
          :rows="3"
          placeholder="请输入内容"
          style="width: 320px;"
          v-model="addForm.visit_content"
        ></el-input>
      </el-form-item>
      <el-form-item label="待办提醒:" style="width: 100%;text-align: left;margin-top: 10px;">
        <el-input
          type="textarea"
          :rows="3"
          placeholder="请输入内容"
          style="width: 320px;"
          v-model="addForm.remind"
        ></el-input>
      </el-form-item>
      <el-form-item label="提醒日期:" style="width: 100%;text-align: left;">
        <el-date-picker
          type="date"
          placeholder="选择日期"
          v-model="addForm.reminder_date"
          :picker-options="pickerOptions"
          style="width: 100%;"
          size="mini"
        ></el-date-picker>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button class="benchBtn" @click="resetForm('ruleForm')">取消</el-button>
      <el-button type="primary" class="benchBtn benchBtnChecked" @click="submitForm('ruleForm')">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
// import eventBus from '../../../eventBus'
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    type: String,
    id: Number,
    name: String
  },
  data() {
    return {
      title: "",
      addForm: {
        customer_id: this.id,
        id: null,
        visit_time: "",
        visit_name: "",
        type: "",
        visit_content: "",
        remind: "",
        reminder_date: ""
      },
      formRule: {
        visit_content: [
          { required: true, message: "请填写回访内容", trigger: "change" }
        ],
        visit_name: [
          { required: true, message: "请填写回访对象", trigger: "change" }
        ],
        type: [
          { required: true, message: "请选择回访方式", trigger: "change" }
        ],
        visit_time: [
          { required: true, message: "请填写回访日期", trigger: "change" }
        ],

      },
      today: "",
      pickerOptions: {
        disabledDate(time) {
          let _now = Date.now();
          let one = 1 * 24 * 60 * 60 * 1000;
          let days = _now - one;
          return time.getTime() <= days;
        }
      },
      returnPickerOptions: {
        disabledDate(time) {
          let _now = Date.now();
          // let one = 1 * 24 * 60 * 60 * 1000;
          // let days = _now + one;
          return time.getTime() > _now;
        }
      }
    };
  },

  async created() {
    this.title = this.type == "modify" ? "修改回访" : "新增回访";
    if (this.type == "modify") {
      let curr = await localStorage.getItem("dw_erp_customer_revisit_form");
      curr = JSON.parse(curr);
      curr.visit_time = curr.visit_time * 1000;
      curr.reminder_date = curr.reminder_date ? curr.reminder_date * 1000 : "";
      curr.type = "" + curr.type;
      this.addForm = curr;
    } else {
      let now = new Date();
      let year = now.getFullYear();     //得到年份
      let month = now.getMonth();       //得到月份
      let date = now.getDate();         //得到日期
      let hour = now.getHours();        //获取当前小时数(0-23)
      let minute = now.getMinutes();    //获取当前分钟数(0-59)
      let second = now.getSeconds();    //获取当前秒数(0-59)
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      this.addForm.visit_time = year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
    }
  },

  computed: {
    showDialog: {
      get: function() {
        return this.show;
      },
      set: function(newValue) {
        if (this.type == "modify") {
          this.$emit("modifyClose");
        } else {
          this.$emit("closeReturn", newValue);
        }
      }
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
         
          let obj = Object.assign({}, this.addForm);
          obj.visit_time = obj.visit_time ? Date.parse(new Date(obj.visit_time)) / 1000 : "";
          obj.reminder_date = obj.reminder_date ? Date.parse(new Date(obj.reminder_date)) / 1000 : "";
           if(obj.reminder_date == '' && obj.remind != ''){
            this.tip('请填写提醒日期', 'warning')
            return
          }
          if (this.type == "modify") {
            this.postFuncLoading("erp/customer.visit.edit", obj, () => {
              this.showDialog = false;
              this.tip("修改成功", "success");
              this.$emit("comfirmEvent");
              // eventBus.$emit("refreshTodoListFrom");
            });
          } else {
            this.postFuncLoading("erp/customer.visit.create", obj, () => {
              this.showDialog = false;
              this.tip("新增成功", "success");
              this.$emit('addConfirmEvent')
            });
          }
        } else {
          return false;
        }
      });
      //刷新客户统计数据 今日待办
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.showDialog = false;
    },
    //对话框关闭事件回调
    closeEvent() {
      this.addForm = {
        customer_id: this.id,
        visit_time: "",
        visit_name: "",
        type: "",
        visit_content: "",
        remind: "",
        reminder_date: ""
      };
      this.$refs["ruleForm"].resetFields();
    }
  },
  destroyed() {
    localStorage.removeItem("dw_erp_customer_revisit_form");
  }
};
</script>

<style scoped lang="scss">
.returnVisit /deep/ .el-dialog__header {
  font-weight: 600;
}
.returnVisit /deep/ .el-textarea__inner {
  font-size: 12px;
  border-color: #666;
}
.returnVisit /deep/ .el-textarea__inner:focus {
  border-color: #666;
}
</style>